import React from 'react';
import '../../css/procesoEmbarque.scss';
import Breadcrumbs from '../Breadcrumbs';
import Footer from '../Footer';

const steps = [
  {
    icon: 'schedule',
    title: 'Llega al puerto con 2 h de antelación.',
    text: 'Revisa la documentación necesaria para el embarque de adultos mayores, así como servicios de asistencia disponibles. Te recomendamos llegar temprano para evitar contratiempos durante el registro.'
  },
  {
    icon: 'confirmation_number',
    title: 'Mantén tu pase de abordar a la mano.',
    text: 'En QR o impreso. Revisa la documentación necesaria para el embarque de adultos mayores, así como servicios de asistencia disponibles. Tenerlo listo agiliza el flujo para todos los pasajeros.'
  },
  {
    icon: 'security',
    title: 'Cruza los filtros de seguridad.',
    text: 'Revisa la documentación necesaria para el embarque de adultos mayores, así como servicios de asistencia disponibles. Nuestro personal está para guiarte a través de los protocolos de seguridad marítima.'
  },
  {
    icon: 'directions_bus',
    title: 'Haz uso de nuestro autobús para abordar.',
    text: 'Revisa la documentación necesaria para el embarque de adultos mayores, así como servicios de asistencia disponibles. Un transporte interno te llevará directamente a la rampa de abordaje del ferry.'
  }
];

export default function Embarque() {
  return (
    <>
      <section className="proceso-embarque">

        {/* HERO */}
        <div className='embarque-hero'>

            <div className='overlay'></div>

            <div className='container hero-content'>

                <div style={{ marginTop: '4rem' }}>
                    <Breadcrumbs />
                </div>

                <h1>
                    Recepción de equipaje
                </h1>

                <p>
                    Bienvenido a su destino. Siga nuestras sencillas instrucciones
                    para una entrega de equipaje rápida y segura.
                </p>

            </div>

        </div>
        <div className="container">

          <div className="proceso-embarque-content">
            {steps.map((step, index) => (
              <div className="embarque-step" key={index}>

                <div className="embarque-step-icon">
                  <div className="icon-circle">
                    <span className="material-symbols-outlined">
                      {step.icon}
                    </span>
                  </div>

                  {index !== steps.length - 1 && (
                    <div className="step-line" />
                  )}
                </div>

                <div className="embarque-step-card">
                  <div className="step-header">
                    <span className="step-number">
                      {index + 1}
                    </span>

                    <h2>{step.title}</h2>
                  </div>

                  <p>{step.text}</p>
                </div>

              </div>
            ))}
          </div>

          <div className="embarque-cta">
            <div className="cta-icon">
              <span className="material-symbols-outlined">
                directions_boat
              </span>
            </div>

            <div className="cta-content">
              <h3>¿Alguna duda adicional?</h3>

              <p>
                Nuestro equipo de atención al cliente está disponible para
                ayudarte con cualquier requerimiento especial o consulta sobre
                tu viaje.
              </p>

              <div className="cta-buttons">
                <button>
                  Ver Preguntas Frecuentes
                </button>

                <button className="secondary">
                  Contactar Soporte
                </button>
              </div>
            </div>
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
}